import ContentTypes from '../../constants/ContentTypes';
import withRequiredAuth from '../../HOC/withRequiredAuth';
import withRequiredProduct from '../../HOC/withRequiredProduct';
import FindWorkshops from './FindWorkshops';

export default withRequiredProduct(
  withRequiredAuth(FindWorkshops),
  ContentTypes.OPEN_WORKSHOP,
);
